import controller from './wf-form-actions.controller';
import template from './wf-form-actions.html';
import './wf-form-actions.scss';

export default {
	controller,
	controllerAs: '$ctrl',
	template,
	bindings:     {
		actionKid: '<?',
		affectKid: '<',

		disabled: '<?ngDisabled',
		kid:      '<',
		wf:       '=',

		onClick:    '&?',
		onCancel:   '&?',
		onRedirect: '&?',

		options:  '<?',
	},
};
